
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import MxModal from '@/components/global/MxModal.vue';
import FileDeviceGeneration from './FileDeviceGeneration.vue';
import { IFileExaminationResult, IFileOriginatingDevice, IFileGenerationHistory, IFileDeviceGeneration, MediaType } from '@/types/resource.types';

@Component({
    name: 'FileStructuralSignatureSummary',
    components: {
        MxModal,
        FileDeviceGeneration
    }
})
export default class FileStructuralSignatureSummary extends Vue {

    @Prop({ type: Object, required: true })
    readonly fileResult: IFileExaminationResult;

    @Prop({ type: Boolean, required: false })
    readonly showHistoryButton: boolean;

    showModal: boolean = false;

    get device(): IFileOriginatingDevice | undefined {
        return this.fileResult?.originatingDevice;
    }

    get history(): IFileGenerationHistory | undefined {
        return this.fileResult?.generationHistory;
    }

    get devices(): IFileDeviceGeneration[] | undefined {
        return this.fileResult?.deviceGenerationHistory;
    }

    get showMatches(): boolean {
        if (this.isDocument) return this.fileResult?.file?.signature1RefMatch === true;
        return (this.fileResult?.matchHistory?.length ?? 0) > 0;
    }

    get isDocument(): boolean {
        return this.fileResult?.mediaType === MediaType.Document;
    }
    
    get classifiedBrand(): string {
        if(this.fileResult.originatingDevice?.classifiedBrand ) {
            return this.fileResult.originatingDevice.classifiedBrand;
        }else if(this.fileResult.brandClassification){
            return this.fileResult.brandClassification.predictedValue;
        }
        return '';
    }

    get classifiedDevice(): string {
        if(this.fileResult.originatingDevice?.classifiedDevice) {
            return this.fileResult.originatingDevice.classifiedDevice;
        }else if(this.fileResult.modelClassification){
            return this.fileResult.modelClassification.predictedValue;
        }
        return '';
    }

    get classifiedLastGeneration(): string {
        if(this.fileResult.lastGenerationClassification?.predictedValue){
            return this.fileResult.lastGenerationClassification.predictedValue;
        }
        return '';
    }
    async loadData() {
        if(!this.$hasAdvancedSubscription) return;
        this.$loading = true;
        try {
            this.showModal = true;
        } catch(e) {
            this.showModal = false;
        }
        this.$loading = false;
    }
}

